module.exports = __webpack_public_path__ + "img/collective_management_item_bg3.ba36cb96.png";